<template>
  <div class="main-login">
    <FormHeader
      :headerTitle="headerTitle"
    />
    <div class="form-body-wrap">
      <router-view />
    </div>
  </div>
</template>
<script>

import FormHeader from "./components/FormHeader";
export default {
  name: "MainLogin",
  components: {
    FormHeader
    // ResetPassword
  },
  data () {
      return {
          headerTitle: 'Forget Password'
      }
  }
};
</script>
